import { useNumberFormat } from 'hooks/useNumberFormat';

type TProps = {
  amount?: number | null;
};

export const RequestedAmountCell = ({ amount }: TProps) => {
  const { formatCurrency } = useNumberFormat();

  return (
    <div data-testid="requested-amount-cell">
      {amount ? formatCurrency(amount) : '-'}
    </div>
  );
};
